import script from "./NoticeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeModal.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeModal.vue?vue&type=style&index=0&id=1de41e86&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-fondueretro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de41e86"]])

export default __exports__